import { useNuxtApp } from 'nuxt/app';

export function getAddress (data) {
  return [data.city ? `${data.city},` : null, data.streetName, data.streetType, data.streetNo].filter(element => Boolean(element)).join(' ');
}

export function getUrlFormattedAddress (data) {
  return [data.postCode, data.city, data.streetName, data.streetType, data.streetNo].filter(element => Boolean(element)).join('+');
}

export function getMapsUrl (data) {
  const nuxt = useNuxtApp();
  return nuxt.$awMergedConfig.googleMapsAddressBaseUrl + getUrlFormattedAddress(data);
}

export function createStockInfosList (stockInfos) {
  return stockInfos.map((stockInfo) => {
    return {
      ...stockInfo,
      addressText: getAddress(stockInfo.store.address),
      mapsUrl: getMapsUrl(stockInfo.store.address),
    };
  });
}
